import * as types from "./types";

const createStatementState = {
  addedInvoices: [],
  toAddInvoices: [],
  statement: {
    code: "",
    status: ""
  },
  error: null
};

export default (state = createStatementState, action) => {
  switch (action.type) {
    case types.CLEAR_STORE: {
      return {
        ...createStatementState
      };
    }
    case types.ADD_INVOICES: {
      const newAddedInvoices = [...state.addedInvoices, ...action.payload];
      return {
        ...state,
        addedInvoices: newAddedInvoices
      };
    }
    case types.REMOVE_INVOICES: {
      const newInvoices = state.addedInvoices.filter(invoice => !action.payload.some(inv => inv.code === invoice.code));
      return {
        ...state,
        addedInvoices: newInvoices
      };
    }
    case types.FETCHING_INVOICE_LIST_SUCCESS: {
      return {
        ...state,
        toAddInvoices: action.payload
      };
    }
    case types.FETCHING_STATEMENT_SUCCESS: {
      const { code, invoices = [], status } = action.payload;
      const addedInvoices = [...state.addedInvoices, ...invoices];
      return {
        ...state,
        addedInvoices,
        statement: {
          code,
          status
        }
      };
    }
    case types.FETCHING_NAME_SUCCESS: {
      return {
        ...state,
        statement: {
          code: action.payload
        }
      };
    }
    case types.FETCHING_STATEMENT_ERROR:
    case types.FETCHING_INVOICE_LIST_ERROR:
    case types.FETCHING_NAME_ERROR:
    case types.CREATE_EDIT_STATEMENT_ERROR: {
      return {
        ...state,
        error: action.payload
      };
    }
    default:
      return state;
  }
};
